import CampaignPanel from 'src/components/ConnectedVehicle/CampaignPanel/CampaignPanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { ConnectedVehicleActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
    checkedCampaign: state.ConnectedVehicle.CheckedCampaign,
    importedCampaign: state.ConnectedVehicle.ImportedCampaign,
    mode: state.Framework.specProfile,
});

const mapDispatchToProps = {
    toggleCampaign: ConnectedVehicleActionCreator.ToggleCampaign,
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignPanel);